import { Component } from 'react'
import { connect } from 'react-redux'
import { FaRegFilePdf } from 'react-icons/fa'
import { If } from 'components/ideal-core-ui'
import { ReplaceProposalFileContainer } from 'components/common/ReplaceProposalFileContainer'
import s from './ProposalFileCellRenderer.scss'
import { Link } from 'react-router-dom'

@connect(() => ({}), null, null, { forwardRef: true })
class ProposalFileCellRenderer extends Component {
  state = {
    showReplaceFileModal: false
  }

  toggleReplaceFileModal = () => {
    this.setState(prevState => ({
      showReplaceFileModal: !prevState.showReplaceFileModal
    }))
  }

  render() {
    const { data, fileUrl, dealId, path } = this.props
    if (!data) return null
    const { s3ContentKey, id } = data
    const { showReplaceFileModal } = this.state
    return (
      <div className={s.fileWrapper}>
        <FaRegFilePdf />
        <a className={s.fileLink} href={`/${path}/${id}`}>
          Details
        </a>
        <If
          condition={s3ContentKey}
          fallback={
            <>
              <Link className={s.replaceLink} to="#" onClick={this.toggleReplaceFileModal}>
                Add file
              </Link>
              <ReplaceProposalFileContainer
                proposal={data}
                dealId={dealId}
                showReplaceFileModal={showReplaceFileModal}
                toggleReplaceFileModal={this.toggleReplaceFileModal}
                isCreate
              />
            </>
          }
        >
          <a
            className={s.fileLink}
            href={`${fileUrl}/${s3ContentKey}`}
            target="_blank"
            rel="noopener noreferrer"
          >
            View
          </a>
          <>
            <Link className={s.replaceLink} to="#" onClick={this.toggleReplaceFileModal}>
              Replace
            </Link>
            <ReplaceProposalFileContainer
              proposal={data}
              showReplaceFileModal={showReplaceFileModal}
              toggleReplaceFileModal={this.toggleReplaceFileModal}
              dealId={dealId}
            />
          </>
        </If>
      </div>
    )
  }
}

export default ProposalFileCellRenderer
